"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInquirySource = void 0;
var getInquirySource = function (_a) {
    var points = _a.points, shouldCluster = _a.shouldCluster, onClick = _a.onClick;
    var inquiries = points;
    return {
        layers: [
            {
                data: {
                    id: "inquiry-cluster",
                    type: "circle",
                    source: "inquiries",
                    filter: ["has", "point_count"],
                    paint: {
                        "circle-radius": 20,
                        "circle-color": "#123cd4",
                        "circle-stroke-color": "#FFFFFF",
                        "circle-stroke-width": 2,
                    },
                },
                onClick: function (e, map) {
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["inquiry-cluster"],
                    });
                    // @ts-ignore
                    var clusterId = features[0].properties.cluster_id;
                    map
                        .getSource("inquiries")
                        // @ts-ignore
                        .getClusterExpansionZoom(clusterId, function (err, zoom) {
                        if (err)
                            return;
                        // @ts-ignore
                        var center = features[0].geometry.coordinates;
                        map.easeTo({
                            center: center,
                            zoom: zoom,
                        });
                    });
                },
                onMouseEnter: function (e, map) {
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    map.getCanvas().style.cursor = "";
                },
            },
            {
                data: {
                    id: "inquiries-cluster-count",
                    type: "symbol",
                    source: "inquiries",
                    filter: ["has", "point_count"],
                    layout: {
                        "icon-allow-overlap": true,
                        "text-allow-overlap": true,
                        "text-field": "{point_count_abbreviated}",
                        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                        "text-size": 12,
                    },
                    paint: { "text-color": "#FFFFFF" },
                },
            },
            {
                data: {
                    id: "inquiries-unclustered-point",
                    type: "circle",
                    source: "inquiries",
                    filter: ["!", ["has", "point_count"]],
                    paint: {
                        "circle-color": "#0000FF",
                        "circle-radius": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            20,
                            4,
                        ],
                        "circle-stroke-width": 2,
                        "circle-stroke-color": "#ffffff",
                    },
                },
                onClick: function (e, map) {
                    var _a, _b, _c, _d;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["inquiries-unclustered-point"],
                    });
                    // @ts-ignore
                    var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                    map.easeTo({
                        center: center,
                    });
                    if (onClick) {
                        onClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                    }
                },
                onMouseEnter: function (e, map) {
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    map.getCanvas().style.cursor = "";
                },
            },
            {
                data: {
                    id: "inquiries-highlighted-point",
                    type: "circle",
                    source: "inquiries",
                    filter: ["in", "id", ""],
                    paint: {
                        "circle-color": "#0000FF",
                        "circle-radius": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            20,
                            6,
                        ],
                        "circle-stroke-width": 3,
                        "circle-stroke-color": "#ffffff",
                    },
                },
            },
        ],
        sourceId: "inquiries",
        source: {
            type: "geojson",
            cluster: shouldCluster,
            clusterMaxZoom: 14,
            clusterRadius: 25,
            data: {
                type: "FeatureCollection",
                features: inquiries.map(function (inquiry) {
                    var _a, _b;
                    return ({
                        type: "Feature",
                        properties: {
                            id: inquiry.id,
                            "icon-image": "image-container",
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                (_a = inquiry === null || inquiry === void 0 ? void 0 : inquiry.location) === null || _a === void 0 ? void 0 : _a.longitude,
                                (_b = inquiry === null || inquiry === void 0 ? void 0 : inquiry.location) === null || _b === void 0 ? void 0 : _b.latitude,
                            ],
                        },
                    });
                }),
            },
        },
        images: []
    };
};
exports.getInquirySource = getInquirySource;
